// Exercise time is separate from authentication, print-help and shared-session time.
export class PauseClock {
  private stoppedAt: number | null = null;
  private total = 0;
  private nextId = 0;
  private timers = new Map<number, { callback: () => void; due: number; native?: ReturnType<typeof setTimeout> }>();
  constructor(private readonly realNow: () => number = Date.now) {}
  now() { return (this.stoppedAt ?? this.realNow()) - this.total; }
  paused() { return this.stoppedAt !== null; }
  synchronize(total: number, stoppedAt: number | null) {
    if (this.total === total && this.stoppedAt === stoppedAt) return;
    this.total = total;
    this.stoppedAt = stoppedAt;
    for (const [id, timer] of this.timers) {
      if (timer.native !== undefined) clearTimeout(timer.native);
      timer.native = undefined;
      if (!this.paused()) this.schedule(id, timer);
    }
  }
  setTimeout(callback: () => void, delay = 0) {
    const id = ++this.nextId;
    const timer = { callback, due: this.now() + Math.max(0, delay) };
    this.timers.set(id, timer);
    if (!this.paused()) this.schedule(id, timer);
    return id;
  }
  private schedule(id: number, timer: { callback: () => void; due: number; native?: ReturnType<typeof setTimeout> }) {
    timer.native = setTimeout(() => { this.timers.delete(id); timer.callback(); }, Math.max(0, timer.due - this.now()));
  }
  clearTimeout(id: number) { const timer = this.timers.get(id); if (timer?.native !== undefined) clearTimeout(timer.native); this.timers.delete(id); }
  clear() { for (const id of this.timers.keys()) this.clearTimeout(id); this.total = 0; this.stoppedAt = null; }
}

let activeClock: PauseClock | null = null;
const fallback = new PauseClock();
export function activateExerciseClock(clock: PauseClock | null) { activeClock = clock; }
export function exerciseNow(realNow: () => number) { return activeClock?.now() ?? realNow(); }
export function exerciseIsPaused() { return activeClock?.paused() ?? false; }
export function setExerciseTimeout(callback: () => void, delay?: number) { return (activeClock ?? fallback).setTimeout(callback, delay); }
export function clearExerciseTimeout(id: number) { activeClock?.clearTimeout(id); fallback.clearTimeout(id); }
